import {Observable} from 'rxjs';
import i18next from 'i18next';

import {combineEpics} from 'web-app/util/redux-observable';
import * as AccountItemApi from 'web-app/react/entities/account-items/api';
import generateUUID from 'web-app/util/uuid';
import * as GlobalEventActions from 'web-app/react/global-event/actions';
import {
    NO_ITEMS_TO_INVOICE_ERROR_CODE,
    NO_ITEMS_TO_INVOICE_GQL_ERROR_CODE,
} from 'web-app/react/plans/debt-report/batch-invoice/constants';

import * as Actions from './actions';

const previewInvoiceWithGraphQL = action$ =>
    action$
        .ofType(Actions.previewInvoiceWithGraphQL.type)
        .debounceTime(300)
        .mergeMap(({payload}) => {
            const requestId = generateUUID();

            const {invoiceVariables} = payload;

            return Observable.concat(
                Observable.of(Actions.storeInvoicePreviewId.action(requestId)),
                AccountItemApi.createInvoiceInApollo(invoiceVariables)
                    .flatMap(result => [
                        Actions.previewInvoiceWithGraphQLSuccess.action({
                            requestId,
                            result,
                        }),
                    ])
                    .catch(e => {
                        if (
                            e &&
                            (e.errorCode === NO_ITEMS_TO_INVOICE_GQL_ERROR_CODE ||
                                e.errorCode === NO_ITEMS_TO_INVOICE_ERROR_CODE)
                        ) {
                            return Observable.of(Actions.previewInvoiceWithGraphQLAborted.action({requestId}));
                        } else {
                            const errorMessage = e ? e.error : i18next.t('somethingWentWrong');
                            return Observable.concat(
                                Observable.of(GlobalEventActions.updateError.action(errorMessage)),
                                Observable.of(Actions.previewInvoiceWithGraphQLFailed.action(e)),
                            );
                        }
                    }),
            );
        });

export default combineEpics(previewInvoiceWithGraphQL);
